import { useEffect, useContext, useRef } from 'react';
import { withApollo, graphql } from 'react-apollo';
import _get from 'lodash/get';
import * as routeUtils from 'utils/routes';

import gqlQueryGetApps from 'graphql/queries/get-apps';
import clientGqlMutUpdateAppContext from 'graphql/mutations/update-app-context';
import { LoaderContext } from 'components/theme/loader';
import withGraphqlLoaderHOC from 'components/theme/loader/with-graphql-loader-hoc';

function InitAppContext(props) {
  const { hideLoader } = useContext(LoaderContext);
  const compRef = useRef({});

  const { client, loaderQueueId } = props;
  const appsFetched = _get(props, 'data.queryGetApps', []);

  let appId = routeUtils.path.getAppIdFromPath();

  appId = appId || _get(appsFetched, '[0].appId');

  useEffect(() => {
    if (!appId) {
      return () => {};
    }

    const promise = client.mutate({
      mutation: clientGqlMutUpdateAppContext,
      variables: {
        appId
      }
    });

    promise.catch(console.warn).finally(() => {
      compRef.current.hideLoaderTimeOut = setTimeout(() => {
        hideLoader(loaderQueueId);
      });
    });

    return function cleanup() {
      clearTimeout(compRef.current.hideLoaderTimeOut);
    };
  }, [appId]);

  return true;
}

const InitAppContextWithGraphqlLoder = withGraphqlLoaderHOC(
  InitAppContext,
  [{ name: 'queryGetApps', data: 'listApplications.items' }],
  {
    hideLoaderComp: false,
    fadeOutFull: true
  }
);
const InitAppContextComponent = graphql(gqlQueryGetApps, {
  name: 'queryGetApps'
})(InitAppContextWithGraphqlLoder);

export default withApollo(InitAppContextComponent);
